import {COLORS} from '../../../../constants/colors';

export const badgeColors = {
  colors: {
    default: COLORS.Black,
    sale: COLORS.White,
    coupon: COLORS.White,
  },
  backgroundColors: {
    default: COLORS.White,
    basket: COLORS['Alerts.Success.Secondary'],
    sale: COLORS.RedSale,
    campaign: COLORS.RedSale,
    primaryCoupon: COLORS['Coupon.Primary'],
  },
};
